package com.example.mystybag.config

import androidx.compose.ui.unit.Dp
import com.example.mystybag.commonData.expected.getOS
import com.example.mystybag.commonData.expected.isInRelease
import com.example.mystybag.commonData.helpers.PlatformDefines.IOS
import com.example.mystybag.sharedmodels.base.UsageInProduct

object ApplicationConfig {
    var iconSize                : Dp?               = null
    var loginIconSize           : Dp?               = null
    var launchClassName         : String            = "com.example.mystybag.appCore.MystyBagActivity"
    var usageInProduct          : UsageInProduct    = UsageInProduct.MYSTYBAG
    const val APPLE_STORE_ID    : String            = "1322347923"

    /**
     * Whether the running build is a merchant-only build (separate APK distributed
     * exclusively to merchants/staff). When true, the Welcome screen hides the
     * "What kind of user are you?" title and the Client/Merchant segment control,
     * and only the merchant flow is reachable.
     *
     * Set by the Android entry point from a build-time resource that is driven by
     * the Gradle property `merchantOnly` (see `composeApp/build.gradle.kts`).
     */
    var isMerchantOnlyBuild     : Boolean           = false

    val salt: String = "V4pHNoSUwMpbUYsLaUFo6xs69AlT/LDgpekrrnfp8g0SEWiP4sM="
}